const EventEmitter = require('event-emitter');
const emitter = EventEmitter({});
import LanguageManager from './../language_manager/language_manager';
import safe from '../../util/safe';

var Controls = (function() {
    var controlsElement = null;
    var controlsElementClass = 'bitdash-ctrl';

    return {
        init: initControls,
        show: show,
        hide: hide,
        lockVisible: lockVisible,
        unlockVisible: unlockVisible,
        initializeTooltipWrapper: initializeTooltipWrapper
    };

    function show() {
        let controlsLayout = getControlsElement();
        if (controlsLayout) {
            controlsLayout.classList.add('bitdash-fadein');
        }
        emitter.emit('controls-show');
    }
    function hide() {
        let controlsLayout = getControlsElement();
        if (controlsLayout) {
            unlockVisible();
            controlsLayout.classList.remove('bitdash-fadein');
        }
        emitter.emit('controls-hide');
    }

    function initControls() {
        document.addEventListener('keydown', function (event) {
            switch (event.which) {
                case 32:
                    disabledEventPropagation(event);
                    event.preventDefault();
                    return false;
                    break;
                default:
                    break;
            }

        });

        var mouseTimer = null,
            cursorVisible = true;

        const disappearCursor = () => {
            mouseTimer = null;
            document.querySelector('.bitdash-ctrl-w').style.cursor = 'none';
            cursorVisible = false;
        };

        document.onmousemove = () => {
            if (mouseTimer) {
                window.clearTimeout(mouseTimer);
            }
            if (!cursorVisible) {
                document.querySelector('.bitdash-ctrl-w').style.cursor = 'default';
                cursorVisible = true;
            }
            mouseTimer = window.setTimeout(disappearCursor, 4000);
        };
    }

    function disabledEventPropagation(e) {
        if (e) {
            if (e.stopPropagation) {
                e.stopPropagation();
            } else if (window.event) {
                window.event.cancelBubble = true;
            }
        }
    }

    function getControlsElement() {
        return controlsElement || document.getElementsByClassName(controlsElementClass)[0];
    }

    function lockVisible() {
        let controlsLayout = getControlsElement();
            if (controlsLayout.className.indexOf('is-locked') === -1) {
            controlsLayout.className += ' is-locked';
        }
        emitter.emit('controls-show');
    }

    function unlockVisible() {
        var controlsLayout = getControlsElement();
        if (controlsLayout.className) controlsLayout.className = controlsLayout.className.replace(' is-locked', '');
        emitter.emit('controls-hide');
    }

    function initializeTooltipWrapper() {
        // Classes for Hover events
        ['play', 'pause', 'mute', 'unmute', 'go-fs', 'cancel-fs'].map(className => {

            const el = safe.code(() => document.querySelector('[data-state=' + className + ']'));

            if (!el) {
                return false;
            }

            const state = el.dataset && el.dataset.state && el.dataset.state.replace(/-/g, '_');
            const debounced = (delay, fn) => {
                let timerId;
                return (...args) => {
                    if (timerId) {
                        clearTimeout(timerId);
                    }
                    timerId = setTimeout(() => {
                        fn(...args);
                        timerId = null;
                    }, delay);
                };
            };

            const toolTip = document.createElement('div');
            toolTip.classList.add('bitdash-btns');
            toolTip.classList.add('bitdash-btns-defaults');
            toolTip.classList.add('bitdash-btns-' + state);
            toolTip.setAttribute('data-tooltip', LanguageManager.get('tooltip_' + state));
            el.parentNode.insertBefore(toolTip, el);
            toolTip.appendChild(el);

            var targetNode = el;
            var observerOptions = {
                childList: true,
                attributes: true,
                subtree: true
            };

            var observer = new MutationObserver(function callback(mutationList, observer) {
                mutationList.forEach((mutation) => {
                    switch (mutation.type) {
                        case 'attributes':
                            const target = mutation.target;
                            const el = target.parentNode;
                            const state = target.dataset && target.dataset.state && target.dataset.state.replace(/-/g, '_');
                            el.setAttribute('data-tooltip', LanguageManager.get('tooltip_' + state));
                            break;
                    }
                });
            });
            observer.observe(targetNode, observerOptions);
        });
    }

}());

module.exports = Controls;



// WEBPACK FOOTER //
// ./src/modules/controls/controls.js